import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Spinner, Col } from 'reactstrap';
import { useDataFetch } from '../../Hooks/Use-data-fetch';

const MonthlyProfits = ({ selectedCountry, dateRange }) => {
  const [startDate, endDate] = dateRange || [];
  const { getData } = useDataFetch();

  const { data: categoryData, isLoading } = getData(
    ['income_by_category', selectedCountry, startDate, endDate],
    '/charts/income-by-category',
    { enabled: !!selectedCountry },
    {
      countryId: selectedCountry,
      startDate: startDate ? startDate.toISOString().split('T')[0] : undefined,
      endDate: endDate ? endDate.toISOString().split('T')[0] : undefined,
    }
  );



  const chartSeries = categoryData?.data?.map(cat => Number(cat.total)) || [];
  const chartLabels = categoryData?.data?.map(cat => cat.categoryName) || [];

  return (
    <Col>
      <Card>
        <CardHeader className="card-no-border">
          <h5>Ingresos por Categoría</h5>
        </CardHeader>
        <CardBody className="pt-0">
          {isLoading ? (
            <div className="text-center py-4">
              <Spinner color="primary" size="sm" />
            </div>
          ) : (
            <div className="monthly-profit">
              <ReactApexChart
                key={selectedCountry}
                type="donut"
                height={300}
                series={chartSeries}
                options={{
                  labels: chartLabels,
                  chart: { type: 'donut', height: 300 },
                  dataLabels: { enabled: false },
                  legend: {
                    position: 'bottom',
                    fontSize: '14px',
                    fontFamily: 'Rubik, sans-serif',
                    fontWeight: 500,
                    markers: { width: 6, height: 6 },
                    itemMargin: { horizontal: 7, vertical: 0 },
                  },
                  stroke: { width: 10, colors: ['var(--light2)'] },
                  plotOptions: {
                    pie: {
                      expandOnClick: false,
                      donut: {
                        size: '83%',
                        labels: {
                          show: true,
                          total: {
                            show: true,
                            label: 'Total',
                            formatter: () => `$ ${chartSeries.reduce((a, b) => a + b, 0)}`,
                          },
                        },
                      },
                    },
                  },
                  colors: ['#54BA4A', 'var(--theme-default)', '#FFA941'],
                }}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default MonthlyProfits;
